import initializeEmbeddedVideos from '../application/javascripts/videos/init';
import initializeTracking from '../application/javascripts/videos/tracking';

window.initializeEmbeddedVideos = initializeEmbeddedVideos;
window.initializeTracking = initializeTracking;
